import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const GoalsPurpose = ({ onNext, onBack }) => {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-black py-4">
      {/* Mobile Container */}
      <div className="w-full max-w-sm mx-auto px-4">
        <div className="flex flex-col min-h-screen bg-zinc-900 rounded-3xl border-2 border-orange-500/30 shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b-2 border-orange-500/30 bg-zinc-900">
            <Button
              onClick={onBack}
              variant="ghost"
              className="flex items-center gap-2 text-orange-500 hover:text-orange-400 text-lg font-bold"
            >
              <ArrowLeft className="w-6 h-6" />
              Back
            </Button>
            <h1 className="text-xl font-black text-orange-500">Goals & Purpose</h1>
            <div className="w-20" />
          </div>

          {/* Content */}
          <div className="flex-grow overflow-y-auto p-6 space-y-6 bg-black">
            <section>
              <h2 className="text-2xl font-black mb-4 text-orange-400">
                Goals of BBLS/ABLS
              </h2>
              <div className="space-y-4 text-lg text-orange-100 leading-relaxed">
                <p>• Standardized approach to burn patient assessment and management</p>
                <p>• Rapid identification of life-threatening conditions</p>
                <p>• Appropriate initial resuscitation and stabilization</p>
                <p>• Timely transfer to burn center when indicated</p>
                <p>• Improved patient outcomes through evidence-based care</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-black mb-4 text-orange-400">
                Purpose
              </h2>
              <div className="space-y-4 text-lg text-orange-100 leading-relaxed">
                <p>
                  This application guides healthcare providers through the systematic assessment and
                  management of burn patients following ABA/ATLS protocols.
                </p>
                <p>
                  It is designed as a clinical decision support tool and should be used in conjunction
                  with clinical judgment and institutional protocols.
                </p>
              </div>
            </section>

            <div className="rounded-2xl bg-yellow-900/40 border-2 border-yellow-500 p-5">
              <h3 className="font-black text-xl text-yellow-300 mb-3">
                Important Disclaimer
              </h3>
              <p className="text-base text-yellow-200 leading-relaxed">
                This tool is for educational and clinical guidance purposes only. It does not replace
                professional medical judgment. Always follow your institution's protocols and consult
                with appropriate specialists for burn management.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="p-4 border-t-2 border-orange-500/30 bg-zinc-900">
            <Button
              onClick={onNext}
              className="w-full h-14 bg-orange-500 text-white text-lg font-black rounded-xl hover:bg-orange-600 transition-colors flex items-center justify-center gap-2 shadow-xl"
            >
              Proceed to Primary Survey
              <ArrowRight className="w-6 h-6" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoalsPurpose;